// src/components/LeadsExplorer/LeadsExplorer.jsx
import React, { useState } from "react";
import styles from "./LeadsExplorer.module.scss";
import LeadsTable from "../LeadsTable/LeadsTable";

const LeadsExplorer = ({ leads, formatDate, updateLeadStatus }) => {
  // 1) Cambiar estado inicial a "todos"
  const [filter, setFilter] = useState("todos");
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectedLead, setSelectedLead] = useState(null);

  console.log("Leads recibidos:", leads);
  const filteredLeads = leads.filter(
    (lead) => filter === "todos" || lead.status === filter
  );
  const sortedLeads = [...filteredLeads].sort((a, b) =>
    sortOrder === "asc"
      ? new Date(a.created_at) - new Date(b.created_at)
      : new Date(b.created_at) - new Date(a.created_at)
  );
  console.log("Leads tras filter+sort:", sortedLeads);

  const fieldLabels = {
    id: "ID",
    name: "Nombres",
    lastname: "Apellidos",
    phone: "Teléfono",
    email: "Correo",
    city: "Ciudad",
    company: "Empresa",
    ruc: "RUC",
    machines: "Máquinas",
    status: "Estado",
    created_at: "Fecha de creación",
  };
  const fieldKeys = [
    "id","name","lastname","phone","email",
    "city","company","ruc","machines","status","created_at",
  ];

  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));

  const getStatusClass = (status) => {
    switch (status) {
      case "nuevo": return styles.statusNew;
      case "archivado": return styles.statusArchived;
      case "atendido": return styles.statusAttended;
      default: return "";
    }
  };
  const closeModal = () => setSelectedLead(null);

  return (
    <>
      <div className={styles.filterContainer}>
        <label htmlFor="status-filter">Filtrar por estado:</label>
        <select
          id="status-filter"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value="todos">Todos</option>
          <option value="nuevo">Nuevo</option>
          <option value="atendido">Atendido</option>
                    <option value="archivado">Archivado</option>
        </select>
      </div>

      <LeadsTable
        leads={sortedLeads}
        formatDate={formatDate}
        updateLeadStatus={updateLeadStatus}
        sortOrder={sortOrder}
        toggleSortOrder={toggleSortOrder}
        onViewMore={setSelectedLead}
      />

      {selectedLead && (
        <div className={styles.modal} onClick={closeModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <h2>{selectedLead.name}</h2>
            {fieldKeys.map((key) => {
              const raw = selectedLead[key];
              const display =
                key === "created_at"
                  ? formatDate(raw)
                  : raw?.toString().trim()
                    ? raw
                    : "—";
              return (
                <p key={key}>
                  <strong>{fieldLabels[key] || key}:</strong> {display}
                </p>
              );
            })}
            <button onClick={closeModal} className={styles.button}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadsExplorer;
